import React, { forwardRef } from 'react'
import { CommonButton, CommonButtonProps } from './common-button'
import { ButtonSizeEnum, ButtonTypeEnum } from './enums'

export interface IconButtonWithTypeProps
  extends Omit<
    CommonButtonProps,
    'type' | 'iconBefore' | 'iconAfter' | 'children'
  > {}

export const PrimaryIconButton = forwardRef<
  HTMLButtonElement,
  IconButtonWithTypeProps
>(({ ...props }, ref) => (
  <CommonButton
    ref={ref}
    type={ButtonTypeEnum.Primary}
    size={ButtonSizeEnum.Medium}
    {...props}
  />
))

export const SecondaryIconButton = forwardRef<
  HTMLButtonElement,
  IconButtonWithTypeProps
>(({ ...props }, ref) => (
  <CommonButton
    ref={ref}
    type={ButtonTypeEnum.Secondary}
    size={ButtonSizeEnum.Medium}
    {...props}
  />
))

export const TertiaryIconButton = forwardRef<
  HTMLButtonElement,
  IconButtonWithTypeProps
>(({ ...props }, ref) => (
  <CommonButton
    ref={ref}
    type={ButtonTypeEnum.Tertiary}
    size={ButtonSizeEnum.Medium}
    {...props}
  />
))

export const GhostIconButton = forwardRef<
  HTMLButtonElement,
  IconButtonWithTypeProps
>(({ ...props }, ref) => (
  <CommonButton
    ref={ref}
    type={ButtonTypeEnum.Ghost}
    size={ButtonSizeEnum.Medium}
    {...props}
  />
))

export const GrayIconButton = forwardRef<
  HTMLButtonElement,
  IconButtonWithTypeProps
>(({ ...props }, ref) => (
  <CommonButton
    ref={ref}
    type={ButtonTypeEnum.Gray}
    size={ButtonSizeEnum.Medium}
    {...props}
  />
))
